import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './userManagement.intl.json';

export const useUserManagementIntl = () => useIntlModule(messages);
